import { render } from "./LabsPage.vue?vue&type=template&id=fba9174e"
import script from "./LabsPage.vue?vue&type=script&lang=js"
export * from "./LabsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__